import React from 'react';

import { Box } from '@rover/kibble/core';
import Markdown from '@rover/pages/src/facility/FacilityProfilePage/components/Markdown';

const NavbarBannerBHMessage = ({ bannerMessage }: { bannerMessage: string }): JSX.Element => {
  return (
    <Box
      display="inline-block"
      sx={{
        '& *': {
          fontSize: '14px !important',
          display: 'inline',
        },
      }}
      mr="2x"
    >
      <Markdown>{bannerMessage}</Markdown>
    </Box>
  );
};

export default NavbarBannerBHMessage;
